import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({ selector: '[appWidgetHost]' })
export class WidgetHostDirective {
  viewContainerRef = inject(ViewContainerRef);
}
